function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 8.5C17.5228 8.5 22 7.15685 22 5.5C22 3.84315 17.5228 2.5 12 2.5C6.47715 2.5 2 3.84315 2 5.5C2 7.15685 6.47715 8.5 12 8.5Z",
  stroke: "#77797F",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.385 7.75C3.31 8.3 2 9.104 2 10C2 11.657 6.477 13 12 13C17.523 13 22 11.657 22 10C22 9.104 20.6905 8.3 18.615 7.75C16.852 8.2165 14.536 8.5 12 8.5C9.464 8.5 7.148 8.2165 5.385 7.75V7.75Z",
  stroke: "#77797F",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.385 12.25C3.31 12.8 2 13.604 2 14.5C2 16.157 6.477 17.5 12 17.5C17.523 17.5 22 16.157 22 14.5C22 13.604 20.6905 12.8 18.615 12.25C16.852 12.7165 14.536 13 12 13C9.464 13 7.148 12.7165 5.385 12.25V12.25Z",
  stroke: "#77797F",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.385 16.75C3.31 17.3 2 18.104 2 19C2 20.657 6.477 22 12 22C17.523 22 22 20.657 22 19C22 18.104 20.6905 17.3 18.615 16.75C16.852 17.217 14.536 17.5 12 17.5C9.464 17.5 7.148 17.217 5.385 16.75V16.75Z",
  stroke: "#77797F",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcDataMaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDataMaster);
export default __webpack_public_path__ + "static/media/ic_data_master.30c93d61.svg";
export { ForwardRef as ReactComponent };